import React from "react";

const NotFound = () => (
  <div className="text-center p-10">
    <h1 className="text-3xl font-bold text-rose-500">404 - Page Not Found</h1>
    <p className="mt-4">Oops! The page you're looking for doesn't exist.</p>
  </div>
);

export default NotFound;
